module.exports = __webpack_public_path__ + "img/background045.c1ca9945.jpg";